import { IconButton, Theme } from '@mui/material';
import styled from 'styled-components';

import {
  TIconButtonVariant,
  TStyledIconButtonProps,
} from './icon-button.types';

const getIconColor = (
  theme: Theme,
  $variant: TIconButtonVariant = 'secondary',
) => {
  if ($variant === 'alert') {
    return theme.palette.error.main;
  }

  if ($variant === 'primary') {
    return theme.palette.primary.main;
  }

  return theme.palette.secondary.light;
};

export const StyledIconButton = styled(IconButton)<TStyledIconButtonProps>`
  && {
    border-radius: ${({ theme }) => theme.shape.buttonRadius.small};
    width: ${({ theme }) => theme.shape.buttonHeight.small};
    height: ${({ theme }) => theme.shape.buttonHeight.small};
    background-color: ${({ $clicked, theme }) =>
      $clicked ? theme.palette.primary.light : 'transparent'};

    &:hover {
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    & > svg {
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ $variant, theme }) => getIconColor(theme as Theme, $variant)};
    }

    &:disabled {
      opacity: 0.5;
    }
  }
`;
